export default "__VITE_ASSET__49b618e0__"